function stripMarkdownPrimaryCtaSection(markdownBody) {
  const source = String(markdownBody ?? '');
  if (!source.includes('## 主 CTA')) {
    return source;
  }

  const ctaSectionPattern = /\n## 主 CTA[\s\S]*?(?=\n##\s+|$)/g;
  return source.replace(ctaSectionPattern, '').trimEnd();
}

function stripMarkdownPrimaryTitle(markdownBody) {
  const source = String(markdownBody ?? '');
  if (!source.startsWith('# ')) {
    return source;
  }

  const stripped = source.replace(/^#\s+.+\n+/, '');
  return stripped.trim();
}

function prepareBlogArticleMarkdown(markdownBody) {
  return stripMarkdownPrimaryTitle(stripMarkdownPrimaryCtaSection(markdownBody));
}

export { prepareBlogArticleMarkdown, stripMarkdownPrimaryCtaSection, stripMarkdownPrimaryTitle };
